<ion-split-pane *ngIf="isShowSideMenu">

	<ion-menu contentId="main-content" #menu
		[ngClass]="{'sidebar-hide': isSidebarCollapsed, 'sidebar-show': !isSidebarCollapsed, 'hide-sidebar': !isShowSideMenu}">

		<div class="sidebar" [ngClass]="isSidebarCollapsed?'sidebarcollapse':''">
			<img src="../assets/svgs/header/homazzon-logo.svg" class="logo-size">
			<span class="logo-text" *ngIf="!isSidebarCollapsed">HomeaZZon</span>
			<img *ngIf="!isSidebarCollapsed" class="hoverLink mobile-only" src="assets/svgs/header/back-arrows.svg" width="35" height="35" alt=""
				(click)="toggleSideMenu()">	
				<div *ngIf="isSidebarCollapsed" class="outer-close mobile-only">
					<img src="assets/svgs/header/back-arrows.svg" alt="" (click)="toggleSideMenu()">
				</div>	
  			</div>
		<ion-content class="ion-padding">
			<div class="menuList collapseMenuList" *ngIf="isSidebarCollapsed">
				<ion-list>
					<ion-menu-toggle auto-hide="false" *ngFor="let menuItem of menuItems">
						<ion-item lines="none" (click)="openMenu(menuItem.url)"
							[ngClass]="{'enabled': menuItem.enabled}" routerLink="menuItem.url"
							routerLinkActive="enabled">
							<ion-thumbnail slot="start" class="ion-no-margin">
								<img [src]="menuItem.icon" class="menuImg">
							</ion-thumbnail>
							<ion-label class="ion-no-margin"></ion-label>
						</ion-item>
					</ion-menu-toggle>
				</ion-list>
			</div>
			<div class="menuList" *ngIf="!isSidebarCollapsed">
				<ion-list>
					<ion-menu-toggle auto-hide="false" *ngFor="let menuItem of menuItems">
						<ion-item lines="none" (click)="openMenu(menuItem.url)"
							[ngClass]="{'enabled': menuItem.enabled}" routerLink="menuItem.url"
							routerLinkActive="enabled">
							<ion-thumbnail slot="start" class="ion-no-margin">
								<img [src]="menuItem.icon" class="menuImg">
							</ion-thumbnail>
							<ion-label class="ion-no-margin"> {{menuItem.title}} </ion-label>
						</ion-item>
					</ion-menu-toggle>
				</ion-list>
			</div>
		</ion-content>
	</ion-menu>
</ion-split-pane>